"use strict";
'use client';
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var swr_hooks_1 = require("@l2p/swr-hooks");
var ui_components_1 = require("@l2p/ui-components");
var react_1 = __importStar(require("react"));
var utils_1 = require("../../utils");
var Conditions_1 = __importDefault(require("./Conditions"));
var LeaderBoard_1 = __importDefault(require("./LeaderBoard"));
var LeaderBoardWithPrize_1 = __importDefault(require("./LeaderBoardWithPrize"));
var RepeatedTabs_1 = __importDefault(require("./RepeatedTabs"));
var styles_module_scss_1 = __importDefault(require("./styles.module.scss"));
var Tabs_1 = __importDefault(require("./Tabs"));
var TournamentPrizes_1 = __importDefault(require("./TournamentPrizes"));
var TableWithResultsPrizesAsLists = function (_a) {
    var _b, _c, _d, _e;
    var tournament = _a.tournament, isFinished = _a.isFinished, Header = _a.Header, _f = _a.hasRepeatedTabs, hasRepeatedTabs = _f === void 0 ? true : _f;
    var _g = (0, react_1.useState)(isFinished ? 0 : 1), activeTab = _g[0], setActiveTab = _g[1];
    var translateLocale = (0, swr_hooks_1.useLocaleTranslations)();
    var isFinishedByDate = (tournament === null || tournament === void 0 ? void 0 : tournament.endDate)
        ? new Date(tournament === null || tournament === void 0 ? void 0 : tournament.endDate) < new Date()
        : false;
    var sortedPrizes = (0, react_1.useMemo)(function () {
        var _a, _b;
        return (_b = (_a = tournament === null || tournament === void 0 ? void 0 : tournament.baseTournament) === null || _a === void 0 ? void 0 : _a.rewards) === null || _b === void 0 ? void 0 : _b.sort(function (a, b) { return Number(a === null || a === void 0 ? void 0 : a.position) - Number(b === null || b === void 0 ? void 0 : b.position); });
    }, [(_b = tournament === null || tournament === void 0 ? void 0 : tournament.baseTournament) === null || _b === void 0 ? void 0 : _b.rewards]);
    var currentCurrency = (0, swr_hooks_1.useCurrentCurrency)();
    var loyaltyBonuses = (0, swr_hooks_1.useLoyaltyBonuses)().data;
    var preparedPrizes = (0, react_1.useMemo)(function () {
        return (0, utils_1.generatePrizeTable)({
            prizes: sortedPrizes || [],
            currency: currentCurrency,
            bonuses: loyaltyBonuses || [],
            asList: isFinished,
        });
    }, [currentCurrency, sortedPrizes, loyaltyBonuses, isFinished]);
    var leaderBoardWithPrizes = (0, react_1.useMemo)(function () {
        var _a;
        return (_a = tournament === null || tournament === void 0 ? void 0 : tournament.topScores) === null || _a === void 0 ? void 0 : _a.reduce(function (acc, d, i) {
            if (isFinished) {
                if (preparedPrizes === null || preparedPrizes === void 0 ? void 0 : preparedPrizes[i]) {
                    return __spreadArray(__spreadArray([], acc, true), [
                        __assign(__assign({}, d), { prize: preparedPrizes === null || preparedPrizes === void 0 ? void 0 : preparedPrizes[i] }),
                    ], false);
                }
                return acc;
            }
            return __spreadArray(__spreadArray([], acc, true), [
                __assign(__assign({}, d), { prize: null }),
            ], false);
        }, []);
    }, [isFinished, tournament === null || tournament === void 0 ? void 0 : tournament.topScores, preparedPrizes]);
    var onClickHandler = function (idx) {
        setActiveTab(idx);
    };
    return (react_1.default.createElement("div", { className: styles_module_scss_1.default.container },
        Header ? (react_1.default.createElement(Header, { onClickHandler: onClickHandler, activeTab: activeTab, isFinished: isFinished || isFinishedByDate })) : (react_1.default.createElement(Tabs_1.default, { onClickHandler: onClickHandler, activeTab: activeTab, isFinished: isFinished || isFinishedByDate })),
        activeTab === 0 && (react_1.default.createElement(react_1.Suspense, { fallback: react_1.default.createElement(ui_components_1.LoadingWithContainer, null) }, isFinished ? (react_1.default.createElement(LeaderBoardWithPrize_1.default, { topPlayers: leaderBoardWithPrizes || [], isFinished: isFinished || isFinishedByDate, hasTitle: !Header, tournamentPosition: tournament === null || tournament === void 0 ? void 0 : tournament.me })) : (react_1.default.createElement(LeaderBoard_1.default, { topPlayers: leaderBoardWithPrizes || [], hasTitle: !Header, isFinished: isFinished || isFinishedByDate, tournamentPosition: tournament === null || tournament === void 0 ? void 0 : tournament.me })))),
        activeTab === 1 && (react_1.default.createElement(react_1.Suspense, { fallback: react_1.default.createElement(ui_components_1.LoadingWithContainer, null) },
            react_1.default.createElement(TournamentPrizes_1.default, { prizes: (_c = tournament === null || tournament === void 0 ? void 0 : tournament.baseTournament) === null || _c === void 0 ? void 0 : _c.rewards, userConfirmed: !!(tournament === null || tournament === void 0 ? void 0 : tournament.me), tournamentId: tournament === null || tournament === void 0 ? void 0 : tournament.id, isFinished: isFinished || isFinishedByDate, hasTitle: !Header }))),
        activeTab === 2 && (react_1.default.createElement(react_1.Suspense, { fallback: react_1.default.createElement(ui_components_1.LoadingWithContainer, null) },
            react_1.default.createElement(Conditions_1.default, { description: translateLocale((_e = (_d = tournament === null || tournament === void 0 ? void 0 : tournament.baseTournament) === null || _d === void 0 ? void 0 : _d.descriptions) === null || _e === void 0 ? void 0 : _e.long), userConfirmed: !!(tournament === null || tournament === void 0 ? void 0 : tournament.me), tournamentId: tournament === null || tournament === void 0 ? void 0 : tournament.id, isFinished: isFinished || isFinishedByDate, hasTitle: !Header }))),
        hasRepeatedTabs && (react_1.default.createElement(RepeatedTabs_1.default, { onClickHandler: onClickHandler, activeTab: activeTab }))));
};
exports.default = TableWithResultsPrizesAsLists;
